import React, { useEffect, useState } from 'react';

import { Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import ColoredButton from 'components/ColoredButton';
import general_messages from 'messages/general_messages';
import processing_activities_messages from 'messages/processing_activities_messages';
import validation_messages from 'messages/validation_messages';

type Props = {
  loading?: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => void;
  open: boolean;
};

const SoftDeleteLiaModal: React.FC<Props> = ({ loading = false, onClose, onConfirm, open }) => {
  const { t } = useTranslation();
  const messages = processing_activities_messages.purpose_lia;
  const [reason, setReason] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (open) {
      setReason('');
      setError('');
    }
  }, [open]);

  const handleClose = () => {
    setReason('');
    setError('');
    onClose();
  };

  const handleConfirm = () => {
    if (!reason.trim()) {
      setError(t(validation_messages.required));
      return;
    }

    onConfirm(reason.trim());
  };

  return (
    <Dialog fullWidth maxWidth='sm' onClose={handleClose} open={open}>
      <DialogTitle>{t(messages.soft_delete.title)}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          error={Boolean(error)}
          fullWidth
          helperText={error || t(messages.soft_delete.help)}
          label={t(messages.soft_delete.reason)}
          multiline
          onChange={event => {
            setReason(event.target.value);
            if (error) setError('');
          }}
          rows={4}
          value={reason}
          variant='outlined'
        />
      </DialogContent>
      <DialogActions>
        <ColoredButton
          className=''
          customColor='grey'
          disabled={loading}
          icon={false}
          onClick={handleClose}
          showLoader={false}
          textLike={false}
          variant='outlined'
        >
          {t(general_messages.cancel)}
        </ColoredButton>
        <ColoredButton
          className=''
          customColor='danger'
          disabled={loading}
          icon={false}
          onClick={handleConfirm}
          showLoader={loading}
          textLike={false}
          variant='contained'
        >
          {t(messages.soft_delete.confirm)}
        </ColoredButton>
      </DialogActions>
    </Dialog>
  );
};

export default SoftDeleteLiaModal;
